import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmbedPreviewCard = () => {
  const [previewDevice, setPreviewDevice] = useState('desktop');
  const [isLoading, setIsLoading] = useState(false);

  const devices = [
    { id: 'mobile', label: 'Mobile', icon: 'Smartphone', width: '375px' },
    { id: 'tablet', label: 'Tablet', icon: 'Tablet', width: '768px' },
    { id: 'desktop', label: 'Desktop', icon: 'Monitor', width: '100%' }
  ];

  const handleRefresh = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
  };

  return (
    <div className="bg-card border border-border rounded-md overflow-hidden">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 border-b border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Live Preview
        </h3>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 p-1 bg-muted rounded-md">
            {devices?.map((device) => (
              <button
                key={device?.id}
                onClick={() => setPreviewDevice(device?.id)}
                className={`
                  p-2 rounded transition-smooth
                  ${previewDevice === device?.id
                    ? 'bg-background text-primary' :'text-muted-foreground hover:text-foreground'
                  }
                `}
                title={device?.label}
              >
                <Icon name={device?.icon} size={18} />
              </button>
            ))}
          </div>
          <Button
            variant="outline"
            size="default"
            iconName="RefreshCw"
            iconPosition="left"
            loading={isLoading}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </div>
      </div>
      <div className="p-4 md:p-6 bg-muted min-h-[400px] flex items-center justify-center">
        <div
          className="bg-background rounded-md shadow-elevation-md transition-smooth mx-auto"
          style={{
            width: devices?.find(d => d?.id === previewDevice)?.width,
            maxWidth: '100%'
          }}
        >
          <div className="p-6 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-md flex items-center justify-center">
                <Icon name="public/assets/images/web-forms-logo-1769800970615.png" size={24} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="text-base font-heading font-semibold text-foreground">
                  Contact Form
                </h4>
                <p className="text-xs text-muted-foreground">
                  Preview of embedded form
                </p>
              </div>
            </div>

            <div className="space-y-3">
              <div>
                <label className="text-sm font-medium text-foreground mb-1.5 block">
                  Full Name
                </label>
                <div className="h-10 bg-muted rounded-md border border-border" />
              </div>
              <div>
                <label className="text-sm font-medium text-foreground mb-1.5 block">
                  Email Address
                </label>
                <div className="h-10 bg-muted rounded-md border border-border" />
              </div>
              <div>
                <label className="text-sm font-medium text-foreground mb-1.5 block">
                  Message
                </label>
                <div className="h-24 bg-muted rounded-md border border-border" />
              </div>
            </div>

            <div className="pt-2">
              <div className="h-10 bg-primary/20 rounded-md flex items-center justify-center">
                <span className="text-sm font-medium text-primary">
                  Submit Form
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 border-t border-border bg-muted/50">
        <div className="flex items-center justify-between text-xs">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-success rounded-full" />
              <span className="text-muted-foreground">SSL Enabled</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-success rounded-full" />
              <span className="text-muted-foreground">CDN Active</span>
            </div>
          </div>
          <span className="text-muted-foreground">
            Load time: 0.8s
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmbedPreviewCard;